/**
 * Detail Price History chart (CP-94).
 *
 * Chart.js default cubic interpolation with tension > 0 draws a Bézier that
 * can pass above the highest PriceHistory sample and below the lowest.
 * Monotone cubic keeps every local extremum on an observed sample, so the
 * series stays inside the recorded high and low. Chart.js ignores tension
 * in that mode.
 *
 * One observation day is not a trend. The detail page says so instead of
 * drawing a one-point grid.
 */

export const priceHistoryLineStyle = {
  fill: true,
  tension: 0.4,
  cubicInterpolationMode: 'monotone',
};

export const SINGLE_PRICE_OBSERVATION_COPY = 'Only one price observation so far';

export function observationDayCount(history) {
  const days = new Set();
  const rows = Array.isArray(history) ? history : [];
  for (const point of rows) {
    const day = String(point && point.timestamp != null ? point.timestamp : '').slice(0, 10);
    if (day) days.add(day);
  }
  return days.size;
}

/** Shoppable fare and exactly one collection day. Zero days stays "unavailable". */
export function isSinglePriceObservation(shoppable, history) {
  return Boolean(shoppable) && observationDayCount(history) === 1;
}
